export default "__VITE_ASSET__BXImYqha__"